import { DirectionalHint, IKeytipProps, memoizeFunction } from '@fluentui/react';

import { getBoundingWindowWithPaddingFabric } from '@1js/window-util';

export const deriveMLRTopRowKeytipProps = memoizeFunction((keytipProps?: IKeytipProps, leftAlign?: boolean):
  | IKeytipProps
  | undefined => {
  if (keytipProps) {
    return {
      ...keytipProps,
      offset: leftAlign ? { x: 8, y: -17 } : undefined,
      calloutProps: {
        ...keytipProps.calloutProps,
        gapSpace: 0,
        coverTarget: false,
        directionalHint: leftAlign ? DirectionalHint.topLeftEdge : DirectionalHint.topCenter,
        bounds: getBoundingWindowWithPaddingFabric,
      },
    };
  }
  return undefined;
});

export const deriveMLRMiddleRowKeytipProps = memoizeFunction((keytipProps?: IKeytipProps, leftAlign?: boolean):
  | IKeytipProps
  | undefined => {
  if (keytipProps) {
    return {
      ...keytipProps,
      offset: leftAlign ? { x: 8, y: 0 } : undefined,
      calloutProps: {
        ...keytipProps.calloutProps,
        gapSpace: 12,
        directionalHint: leftAlign ? DirectionalHint.topLeftEdge : DirectionalHint.topCenter,
        bounds: getBoundingWindowWithPaddingFabric,
      },
    };
  }
  return undefined;
});

export const deriveMLRBottomRowKeytipProps = memoizeFunction((keytipProps?: IKeytipProps, leftAlign?: boolean):
  | IKeytipProps
  | undefined => {
  if (keytipProps) {
    return {
      ...keytipProps,
      offset: leftAlign ? { x: 8, y: 24 } : undefined,
      calloutProps: {
        ...keytipProps.calloutProps,
        directionalHint: leftAlign ? DirectionalHint.bottomLeftEdge : DirectionalHint.bottomCenter,
        gapSpace: 0,
        coverTarget: false,
        bounds: getBoundingWindowWithPaddingFabric,
      },
    };
  }
  return undefined;
});
